export default __webpack_public_path__ + "static/car_accident-d845041294a84be5b1321474b2e47281.png";